import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { PLATFORM_ID, Component, Inject, ViewChild, Input } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as ko from 'knockout';

const _booleanConverter = (value) => {
    if (value === null || value === undefined || typeof value === 'boolean')
        return value;
    return value.toString() === 'true';
};
const _numberConverter = (value) => {
    if (value === null || value === undefined || typeof value === 'number')
        return value;
    return parseFloat(value.toString());
};
function _inputConverter(converter) {
    return (target, key) => {
        const definition = Object.getOwnPropertyDescriptor(target, key);
        if (definition) {
            Object.defineProperty(target, key, {
                get: definition.get,
                set: newValue => {
                    definition.set(converter(newValue));
                },
                enumerable: true,
                configurable: true
            });
        }
        else {
            Object.defineProperty(target, key, {
                get: function () {
                    return this['__' + key];
                },
                set: function (newValue) {
                    this['__' + key] = converter(newValue);
                },
                enumerable: true,
                configurable: true
            });
        }
    };
}

class DxReportingComponent {
    constructor(renderer, platformId) {
        this.renderer = renderer;
        this.platformId = platformId;
        this.height = '800px';
        this.width = '100%';
        this.cssClass = '';
    }
    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.callbacks = this.getCallbacks();
            const options = this.getControlOptions();
            this._koBinding = this.getKoBinding(options);
            this.bindingSender = this._koBinding.sender;
            this._koBinding.applyBindings(this.control.nativeElement);
        }
    }
    ngOnDestroy() {
        ko.cleanNode(this.control.nativeElement);
        this._koBinding = null;
        this.bindingSender = null;
        this.callbacks = null;
        this.control = null;
    }
    getEventRaiser() {
        var component = this;
        return (eventName, args) => component.callbacks && component.callbacks[eventName] && component.callbacks[eventName].emit({ sender: component.bindingSender, args: args, component: component });
    }
}
DxReportingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportingComponent, deps: [{ token: i0.Renderer2 }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
DxReportingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: DxReportingComponent, selector: "ng-component", inputs: { height: "height", width: "width", cssClass: "cssClass", rtl: "rtl", developmentMode: "developmentMode" }, viewQueries: [{ propertyName: "control", first: true, predicate: ["control"], descendants: true }], ngImport: i0, template: '', isInline: true });
__decorate([
    _inputConverter(_booleanConverter)
], DxReportingComponent.prototype, "rtl", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportingComponent.prototype, "developmentMode", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportingComponent, decorators: [{
            type: Component,
            args: [{
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { control: [{
                type: ViewChild,
                args: ['control']
            }], height: [{
                type: Input
            }], width: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], rtl: [{
                type: Input
            }], developmentMode: [{
                type: Input
            }] } });

/*
 * Public API Surface of reporting-angular/core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxReportingComponent, _booleanConverter, _inputConverter, _numberConverter };
